import React from 'react';

export function StarOutlineIcon(props: JSX.IntrinsicElements['svg']) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29 28"
            width="29"
            height="28"
            {...props}
        >
            <path
                fill="currentColor"
                d="M23.2 27.3L14.4 21l-8.8 6.3L8.9 17 0 10.9h11L14.4 0l3.4 10.9h11L20 17l3.2 10.3zm-8.8-7.8l6.6 4.7-2.5-7.8 6.4-4.4h-8l-2.5-8-2.6 8.1h-8l6.4 4.4-2.5 7.8 6.7-4.8z"
            />
        </svg>
    );
}
